import { useTranslation } from 'react-i18next';
import PageMeta from '../components/PageMeta';
import useReveal from '../hooks/useReveal';

const LEADER_IMAGES = [
  'https://images.pexels.com/photos/37148345/pexels-photo-37148345.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.unsplash.com/photo-1758600587730-a11917c13b85?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.pexels.com/photos/28446973/pexels-photo-28446973.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.unsplash.com/photo-1745060594679-61578eb592f7?crop=entropy&cs=srgb&fm=jpg&q=85',
];

export default function Leadership() {
  const { t } = useTranslation();
  useReveal();
  const members = t('leadership_page.members', { returnObjects: true }) || [];

  return (
    <div data-testid="leadership-page">
      <PageMeta pageKey="leadership" />
      <section className="px-6 md:px-12 pt-16 md:pt-24 pb-16">
        <div className="max-w-7xl mx-auto">
          <p className="reveal text-[10px] tracking-[0.35em] uppercase text-[#B58F45] mb-8">{t('leadership_page.eyebrow')}</p>
          <h1 className="reveal font-serif text-5xl md:text-7xl lg:text-8xl text-[#0B1F3F] leading-[1.02] tracking-tight max-w-5xl">
            {t('leadership_page.title_pre')} <span className="italic">{t('leadership_page.title_italic')}</span> {t('leadership_page.title_post')}
          </h1>
          <p className="mt-10 max-w-2xl text-[#6B5B4A] text-base leading-relaxed">
            {t('leadership_page.intro')}
          </p>
        </div>
      </section>

      <section className="px-6 md:px-12 pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {members.map((leader, idx) => (
            <article
              key={leader.name}
              data-testid={`leader-card-${idx}`}
              className="group"
            >
              <div className="relative aspect-[3/4] overflow-hidden mb-6 border border-[#0B1F3F]/10 bg-[#EBE3D0]">
                <img
                  src={LEADER_IMAGES[idx] || LEADER_IMAGES[0]}
                  alt={leader.name}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-[1.03] transition-all duration-[900ms]"
                />
                <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#F5EFE1] to-transparent" />
              </div>
              <h3 className="font-serif text-2xl md:text-[26px] text-[#0B1F3F]">{leader.name}</h3>
              <p className="text-[11px] font-sans tracking-[0.2em] uppercase text-[#B58F45] mt-2">
                {leader.role}
              </p>
              <p className="text-[14px] text-[#6B5B4A] mt-5 leading-relaxed">{leader.bio}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="border-t border-[#0B1F3F]/10 bg-[#EBE3D0] py-24 md:py-32 px-6 md:px-12">
        <div className="max-w-5xl mx-auto text-center">
          <p className="reveal text-[10px] tracking-[0.35em] uppercase text-[#B58F45] mb-8">{t('leadership_page.council_eyebrow')}</p>
          <h2 className="reveal font-serif italic text-3xl md:text-5xl text-[#0B1F3F] leading-tight">
            &ldquo;{t('leadership_page.council_quote')}&rdquo;
          </h2>
          <p className="mt-8 text-[#6B5B4A] text-sm tracking-[0.15em] uppercase">
            {t('leadership_page.council_attribution')}
          </p>
        </div>
      </section>
    </div>
  );
}
